@if (element[columnName] | isStringArray) {
  @for (item of element[columnName]; track item) {
    <div>{{ item | translate }}</div>
  }
} @else {
  {{ element[columnName] }}
}
